import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import Tilty from "react-tilty";
import SectionTitle from "../../components/Common/SectionTitle";

// About Images
import shapeImg1 from "../../assets/img/about/icon-shape.png";
import shapeImg2 from "../../assets/img/about/dot-shape.png";
import syrolVideo from "../../assets/img/SYROL.mp4";

const AboutWork = () => {
  useEffect(() => {
    AOS.init();
  });

  // Inline HTML5 video playback; modal no longer needed
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      v.play();
    } else {
      v.pause();
    }
  };

  return (
    <div className="rs-about video-style pt-120 pb-100 md-pt-90 md-pb-70">
      <div className="container relative">
        <div className="icon-shape">
          <Tilty perspective={1200} reverse={true}>
            <img className="shape" src={shapeImg1} alt="shape1" />
          </Tilty>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="img-part media-icon" style={{ position: "relative" }}>
              <video
                className="video-img"
                src={syrolVideo}
                controls
                playsInline
                preload="metadata"
                ref={videoRef}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                style={{ width: "100%", height: "500px", display: "block", objectFit: "cover" }}
              />
              {!isPlaying && (
                <button
                  type="button"
                  aria-label="Play video"
                  onClick={togglePlay}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(0,0,0,0.6)",
                    color: "#fff",
                    cursor: "pointer",
                    zIndex: 2,
                    boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
                    transition: "background 0.2s ease"
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.75)")}
                  onMouseOut={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.6)")}
                >
                  {/* Inline SVG Play Icon */}
                  <svg width="34" height="34" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </button>
              )}
              <div className="dot-shape">
                <Tilty>
                  <img className="" src={shapeImg2} alt="shape1" />
                </Tilty>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-content gray-bg">
              {/* Section Title Start */}
              <SectionTitle
                sectionClass="sec-title mb-46 md-mb-30"
                subtitleClass="sub-title primary"
                titleClass="title"
                title={
                  <>
                    Partner with us to transform your operations, enhance customer experience, and stay ahead of the curve.
                  </>
                }
                descClass="desc pr-36"
                description={
                  'At Syrol, we bridge the gap between technology and finance, delivering secure, scalable, and user-centric solutions. Our team of experts leverages industry insights and latest technologies to drive business success.'
                }
                animateName="fade-up"
                animateDuration="1200"
              />
              {/* Section Title End */}
              <div
                className="btn-part zIndex1"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="150"
              >
                <Link className="readon2" to="/contact-us">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutWork;
